// @ts-nocheck
/* eslint-disable */
import { node } from "~/util/dom";
import { makeEvent } from "~/lib/signals";
import ContentOverlay from "~/content.overlay";
import { getContextMenu } from "~/usermarks/context-menu";
import { _ } from "~/i18n";
import DistanceMeterContent from "~/distancemeter-content";
import Scene from "~/scene";
import { isDetailActive } from "~/util/detail";
import { store } from "~/state/store";
import Notifications from "~/util/notifications";
import { CONFIG } from "~/config";

/**
 * @class Uzivatelske znacky
 *
 * usermarks-activated
 * usermarks-deactivated
 */
export default class UserMarksContent extends ContentOverlay {
	constructor() {
		super();
		this._contentName = "usermarks";
		this._dom = {
			container: node("div", {id:"usermarks"})
		};
		this._buildCloseButton();
		this._contextItem = getContextMenu(_("userMarks.contextItem"), this);
		this._usermarks = null;
		this._loadPromise = null;
		this._usermarks = null;
		this._lastDetailCoords = null;

		Scene.addListener("provider-change", function(event) {
			var data = event.data;

			this._usermarks && this._usermarks.readOnly(this.isActive() && data.newProvider == "m3d");
		}, this);
	}

	destroy() {
		if (this._usermarks) {
			this._usermarks.destroy();
		}
	}

	activate() {
		var dm = Mapy.getComponent("distanceMeter");
		const state = store.getState();
		let item = null;

		// prenasime jeden bod z rucniho mereni
		if (dm.isActive() && (!this._usermarks || (this._usermarks && !this._usermarks.getItems().length))) {
			item = dm.getOneItem();
		// pri aktivaci detailu pokazde preneseme jeho souradnice do mereni
		} else if (isDetailActive(state)) {
			const { mark } = state.detail;

			if (mark) {
				item = {
					coords: Scene.coordsFromWGS84(mark.lon, mark.lat),
				};
			}
		}

		if (item && item.coords && this._lastDetailCoords) {
			const markNew = item.coords.toWGS84();
			const markOld = this._lastDetailCoords.toWGS84();

			if (markOld.lon !== markNew.lon || markOld.lat !== markNew.lat) {
				this.addItem(item.coords);
				this._lastDetailCoords = item.coords;
			}
		}

		Mapy.getComponent("gpx").deactivate();

		if (this.isActive()) {
			while (Mapy.active[0] instanceof ContentOverlay && Mapy.active[0] !== this) {
				Mapy.active[0].deactivate();
			}
			this.show();

			return this;
		} else {
			var max = Mapy.active.length;

			for (var i = 0; i < max; i++) {
				const content = Mapy.active[i];

				if (content instanceof DistanceMeterContent) {
					content.deactivate();
				}
			}
		}

		this._setSEO();

		Scene.getContainer().addEventListener("photo-gallery-close", this);
		Scene.getContainer().addEventListener("photo-detail-close", this);

		var thisSuper = super.activate();

		this._load().then(() => {
			this._usermarks.activate();
			this._usermarks.readOnly(this.isActive() && Scene.isM3dActive());
			makeEvent("usermarks-activated", this);
		}, () => {});

		return thisSuper;
	}

	deactivate() {
		if (!this.isActive()) { return this; }

		if (this._usermarks) {
			this._usermarks.deactivate();
		}

		var output = super.deactivate();

		Scene.getContainer().removeEventListener("photo-gallery-close", this);
		Scene.getContainer().removeEventListener("photo-detail-close", this);

		makeEvent("usermarks-deactivated", this);

		return output;
	}

	show() {
		Mapy.getComponent("layout").setWidth(1);

		if (this._usermarks) {
			this._usermarks.show();
		}

		return super.show();
	}

	hide() {
		if (this._usermarks) {
			this._usermarks.hide();
		}

		return super.hide();
	}

	setState(state) {
		if (!state.uc && !state.likeData) {
			if(this._usermarks) {
				this._usermarks.setState(state || {});
			}
			var promise = new JAK.Promise();
			promise.fulfill();
			return promise;
		}

		var fromHistory = Mapy.getComponent("history").isFromHistory();

		return this._load().then(function() {
			this._usermarks.setState(state || {}, fromHistory);

			if (fromHistory && Scene.isM3dActive()) {
				Mapy.getComponent("history").save(true);
			}
		}.bind(this), () => {});
	}

	getState() {
		return this._usermarks ? this._usermarks.getState() : {};
	}

	// pokud tiskneme, tak jeste ulozime novou URL, protoze je jasne, ze jsme zmenili souradnice
	historyAfterState(state) {
		if ("p" in state && state.p == "3") {
			Mapy.getComponent("history").save(true);
		}
	}

	getMain() {
		return this._usermarks;
	}

	getContextItem() {
		return this._contextItem;
	}

	getOneItem() {
		if (this._usermarks) {
			return this._usermarks.getOneItem();
		}
		return null;
	}

	addItem(coords, label, description) {
		this._load().then(function() {
			this._usermarks.addItem(coords, label, description);
		}.bind(this), () => {});
	}

	setBottomPanel() {
		if (this._usermarks && this._usermarks.getItems().length) {//FIXME nacist z lazyloadove tridy
			let subtitle = _("userMarks.bottomPoint", { NUM: this._usermarks.getItems().length });
			Mapy.getComponent("layout").setBottomPanel(node("h4", { className: "bp-usermarks", innerHTML: subtitle }));
		} else {
			/* prohazovani stateswitche pro mala rozliseni */
			if (Mapy.Util.isSmallResolution() && Mapy.getComponent("layout").getWidth() != 1) {
				Mapy.getComponent("layout").setBottomPanel(node("p", { className: "bp-usermarks empty-bar", innerHTML: _("userMarks.empty", " ") }));
			}
		}
	}

	handleEvent(e) {
		if (e.type == "photo-detail-close" || e.type == "photo-gallery-close") {
			this.isActive() && !Mapy.getComponent("gallery").isActive() && this._setSEO();
		}
	}

	_load() {
		if (!this._loadPromise) {
			Mapy.getComponent("loader").start(true);
			this._loadPromise = import(
				/* webpackChunkName: "usermarks" */
				'~/usermarks/index.ts'
			);
			this._loadPromise.then(module => {
				module.initModule({ store, CONFIG, Scene });
				this._usermarks = new module.default(Notifications);
				this._usermarks.readOnly(this.isActive() && Scene.isM3dActive());
				this._dom.container.appendChild(this._usermarks.getContainer());
			}, () => {}).finally(() => {
				Mapy.getComponent("loader").end(true);
			});
		}

		return this._loadPromise;
	}

	/**
	 * Vraci objekt s nody, ktere se maji pouzit pro tisk
	 */
	getPrintNodes () {
		var div = Mapy.Util.node("div");
		div.appendChild(Mapy.Util.node("p", { innerHTML: "<strong>" + _("userMarks.title") + "</strong>" }));
		var userTitle = this._usermarks.userTitle;
		if (userTitle) {
			div.appendChild(Mapy.Util.node("p", { textContent: userTitle, className: "user-title" }));
		}
		var likeText = this._usermarks.likeText //text o uložení ve složce
		if (likeText) {
			var cloneContainer = likeText.cloneNode(true);
			cloneContainer.classList.add("like-save-folder");
			div.appendChild(cloneContainer);
		}
		return {
			title: div,
			panel: this._usermarks && this._usermarks.getItems().length ? undefined : Mapy.Util.node("div")
		}
	}

	_setSEO() {
		Mapy.SEO.set(_("userMarks.seo"));
	}
}
